<template>
  <TaskSchedules />
</template>

<script>
import TaskSchedules from "@/components/pages/client/TaskSchedules.vue";

export default {
  name: 'TaskSchedulesPage',
  components: {TaskSchedules},
};
</script>
